import { useEffect, useState } from 'react';
import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';

const getQuarantinedTests = async (selectedPlatform) => {
  try {
    const isAllPlatforms = !selectedPlatform || selectedPlatform === "All platforms";
    const endpoint = isAllPlatforms ? "quarantine" : `quarantine?repository=${selectedPlatform}`;
    const response = await api.get(`${QUALITY_SERVICE_API_URL}/${endpoint}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching test results:', error);
    throw error;
  }
};

const useQuarantinedTests = (selectedPlatform, selectedUnit) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const result = await getQuarantinedTests(selectedPlatform);
        let filteredResult = result.tests;

        // Filter by unit if a specific unit is selected
        if (selectedUnit && selectedUnit !== "All units") {
          filteredResult = filteredResult.filter(test => test.unit === selectedUnit);
        }

        const sortedResult = filteredResult.sort((a, b) => b.fail_counter - a.fail_counter);
        setData(sortedResult);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedPlatform, selectedUnit]);

  return { data, loading, error };
};

export default useQuarantinedTests; 
